import { Dropdown, DropdownItem, IconButton, Icons, Toggler } from 'plume-ui';
import { FunctionComponent, memo, useMemo, useState } from 'react';

import FormattedMessage from '../../../../../utils/components/FormattedMessage';
import { FilterPatternType, LocationFilterType } from '../types';
import { getInputForFilter } from './helpers';

type LocationFilterItemProps = {
  filter: LocationFilterType;
  onDelete: () => void;
  onChange?: (data: any) => void;
  onChangeOperator?: (operator: string) => void;
  allowedOperators?: string[];
  showBooleanOperators?: boolean;
};

const LocationFilterItem: FunctionComponent<LocationFilterItemProps> = ({
  filter,
  allowedOperators,
  onDelete,
  onChange,
  onChangeOperator,
  showBooleanOperators,
}) => {
  const [selectedOperator, setSelectedOperator] = useState(
    filter.operator || allowedOperators?.[0] || '=',
  );

  const handleInputChange = (data: any) => {
    onChange?.(data);
  };

  const input = useMemo(() => {
    return getInputForFilter(filter);
  }, [filter.pattern, filter.dataType, filter.allowedValues]);

  if (!input) return null;

  return (
    <>
      <div className="FilterItem FilterConfig__section">
        <div className="FilterItem__column FilterItem__deleteButton">
          <IconButton onClick={onDelete}>
            <Icons.CrossIcon />
          </IconButton>
        </div>
        <div className="FilterItem__column" data-testid="attribute">
          {filter.attribute}
        </div>
        <div className="FilterItem__column" data-testid="criteria">
          {allowedOperators && allowedOperators.length > 1 ? (
            <Dropdown
              label={
                <FormattedMessage
                  id={`monitorAdd.operators.${selectedOperator}`}
                />
              }
              closeOnItemClick
              openInPortal
            >
              {allowedOperators.map((operator) => (
                <DropdownItem
                  onClick={() => {
                    setSelectedOperator(operator);
                    onChangeOperator?.(operator);
                  }}
                  selected={selectedOperator === operator}
                  key={operator}
                >
                  <FormattedMessage id={`monitorAdd.operators.${operator}`} />
                </DropdownItem>
              ))}
            </Dropdown>
          ) : (
            <FormattedMessage id={`monitorAdd.operators.${selectedOperator}`} />
          )}
        </div>
        <div className="FilterItem__column" data-testid="value">
          <div
            className={`FilterItem__input FilterItem__input-locationFilter FilterItem__input-${
              filter.pattern || filter.dataType
            } FilterItem__input-${selectedOperator}`}
          >
            {input.render({ filter, onChange: handleInputChange })}
          </div>
          {filter.pattern === FilterPatternType.Time &&
            selectedOperator !== 'now' && (
              <FormattedMessage id={'monitorAdd.days'} />
            )}
        </div>
      </div>
      {showBooleanOperators && (
        <div className="FilterItem__booleanOperator">
          <Toggler
            toggleElements={[
              { label: 'AND', key: 'AND' },
              {
                label: 'OR',
                key: 'OR',
              },
            ]}
          />
        </div>
      )}
    </>
  );
};

export default memo(LocationFilterItem);
